function applySelectedLabel(context, event) {}

export default applySelectedLabel
